  document.addEventListener('DOMContentLoaded', function () {
    const fatFooterLinks = document.querySelector('.fat-footer-links');
    if(fatFooterLinks) {
        const ulElements = fatFooterLinks.querySelectorAll('.fat-footer-links ul');

    // Set dynamic widths for ul elements based on count
    if (ulElements.length > 0 && window.innerWidth > 1439) {
      const count = Math.min(ulElements.length, 7); // Use 7 as maximum if more than 7 ul elements
      const width = `calc((100% - ${(count - 1) * 24}px) / ${count})`;
      ulElements.forEach(ul => {
        ul.style.flex = `0 1 ${width}`;
      });
    }

    if (ulElements.length > 0 && window.innerWidth > 1023 && window.innerWidth < 1440) {
        // Create two column containers
        const column1 = document.createElement('div');
        column1.classList.add('footer-column');
        const column2 = document.createElement('div');
        column2.classList.add('footer-column');
        
        const half = Math.ceil((ulElements.length + 1) / 2);

        // Distribute ul elements into two columns
        ulElements.forEach((ul, index) => {
        if (index < half) {
            column1.appendChild(ul);
        } else {
            column2.appendChild(ul);
        }
        });

        // Remove all ul elements from fat-footer-links and append columns
        fatFooterLinks.innerHTML = '';
        fatFooterLinks.appendChild(column1);
        fatFooterLinks.appendChild(column2);
    }
    }
    const labels = document.querySelectorAll('.fat-footer-links .accordion-head');
    
    if(window.innerWidth < 1024) {
        labels.forEach(label => {
        label.addEventListener('click', function () {
            const ul = this.parentElement;
            ul.classList.toggle('active');
        });
        });
    }
    
  });
